module.exports = __webpack_public_path__ + "img/level_five_lock.f9beb737.png";